/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesPlutusPaymentStatus;
(function (FxIdDomainEntitiesPlutusPaymentStatus) {
    FxIdDomainEntitiesPlutusPaymentStatus[FxIdDomainEntitiesPlutusPaymentStatus["Created"] = 0] = "Created";
    FxIdDomainEntitiesPlutusPaymentStatus[FxIdDomainEntitiesPlutusPaymentStatus["Payed"] = 1] = "Payed";
    FxIdDomainEntitiesPlutusPaymentStatus[FxIdDomainEntitiesPlutusPaymentStatus["Cancelled"] = 2] = "Cancelled";
    FxIdDomainEntitiesPlutusPaymentStatus[FxIdDomainEntitiesPlutusPaymentStatus["Unknown"] = 99] = "Unknown";
    FxIdDomainEntitiesPlutusPaymentStatus[FxIdDomainEntitiesPlutusPaymentStatus["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesPlutusPaymentStatus || (FxIdDomainEntitiesPlutusPaymentStatus = {}));
export function instanceOfFxIdDomainEntitiesPlutusPaymentStatus(value) {
    for (const key in FxIdDomainEntitiesPlutusPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesPlutusPaymentStatus, key)) {
            if (FxIdDomainEntitiesPlutusPaymentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesPlutusPaymentStatusFromJSON(json) {
    return FxIdDomainEntitiesPlutusPaymentStatusFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesPlutusPaymentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesPlutusPaymentStatusToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesPlutusPaymentStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesPlutusPaymentStatus.js.map